import { generateServiceId } from "@core/domains/identity";

export const TAXONOMY_SERVICE = {
  ID: generateServiceId("taxonomy"),
  LABEL: "taxonomy",
} as const;
